import { makeEntityScaffold } from '@classpass/saga-tools';
import URLS from 'constants/urls';
import { transformClientResponse, renameKeys } from 'helpers/core';
import httpRetry from 'helpers/http-retry';

const KEY_MAP = {
  classDate: 'scheduleDate', // for consistency
  className: 'scheduleName', // to prevent collisions with React
  networkReservationsCap: 'networkCap',
  teacherId: 'instructorId',
  teacherName: 'instructorName',
};

const handler = ({ httpClient }, venueId, scheduleId, historyCount = 4) => {
  const endpoint = URLS.schedule.insights(venueId, scheduleId, historyCount);
  return httpRetry(opts => httpClient.get(endpoint, opts))
    .then(transformClientResponse)
    .then(data => renameKeys(data, KEY_MAP))
    .then(data => {
      const { history = [], schedule: { payouts = {} } = {} } = data;
      return { history, payouts, scheduleId };
    });
};

export default makeEntityScaffold('SAGA.API.SCHEDULE.INSIGHTS', handler, { defaultKey: 2 });
